import { NavLink } from 'react-router';
import {
  ChartNoAxesColumn,
  LayoutGrid,
  Mail,
  Settings,
  Users,
  Workflow,
  type LucideIcon,
} from 'lucide-react';
import { useAuth } from '../../lib/auth';

const ITEMS: { to: string; label: string; icon: LucideIcon; end?: boolean }[] = [
  { to: '/', label: 'Overview', icon: LayoutGrid, end: true },
  { to: '/kampagner', label: 'Campaigns', icon: Mail },
  { to: '/kontakter', label: 'Contacts', icon: Users },
  { to: '/automatiseringer', label: 'Automations', icon: Workflow },
  { to: '/statistik', label: 'Statistics', icon: ChartNoAxesColumn },
  { to: '/indstillinger/afsendere', label: 'Settings', icon: Settings },
];

export function initials(email: string | null | undefined): string {
  const local = (email ?? '').split('@')[0] ?? '';
  const parts = local.split(/[._-]+/).filter(Boolean);
  const letters =
    parts.length > 1 ? `${parts[0]?.[0] ?? ''}${parts[1]?.[0] ?? ''}` : local.slice(0, 2);
  return letters.toUpperCase() || '?';
}

/** The editor's own 60px icon rail (a sticky 52px bar on phones), replacing the wide app sidebar. */
export function EditorNav() {
  const { user } = useAuth();
  return (
    <nav className="pf-nav" aria-label="Main">
      <div className="pf-logo" aria-hidden="true">
        N
      </div>
      {ITEMS.map(({ to, label, icon: Icon, end }) => (
        <NavLink key={to} to={to} end={end ?? false} aria-label={label} className="pf-navbtn">
          <Icon aria-hidden="true" />
          <span className="pf-tip" aria-hidden="true">
            {label}
          </span>
        </NavLink>
      ))}
      <div className="pf-me" title={user?.email ?? undefined}>
        <span className="pf-sr">Signed in as {user?.email ?? 'you'}</span>
        <span aria-hidden="true">{initials(user?.email)}</span>
      </div>
    </nav>
  );
}
